import { connect } from 'react-redux';
import React from 'react';
import { Form } from 'antd';
import * as valid from 'utils/validate';
import {
  KBInput,
  KBSelect,
KBFormError,
KBButton,
KBTextarea,
KBUserInput } from
'components';
import { arrayToObject, objectToArray } from 'utils/kbUtil';
import { api } from 'app/services';
import * as selectors from 'app/selectors';
import { LOCATION_TYPES } from 'app/constants';

const getChangeValue = value => (value && value.target ? value.target.value : value);

function FormField({ children, error, onChange, onClearError, touched, value }) {
  return children({
    value,
    touched,
    error,
    onChange: nextValue => {
      onChange(getChangeValue(nextValue));
      onClearError();
    }
  });
}

function LocationBaseForm(props) {
  const {
    cities: allCities,
    devices,
    error,
    location,
    locationGroups,
    provinces,
    updateLocation
  } = props;
  const [form] = Form.useForm();
  const [locationStores, setLocationStores] = React.useState([]);
  const [errors, setErrors] = React.useState({});
  const [submitting, setSubmitting] = React.useState(false);
  const initialValues = React.useMemo(
    () => getInitialValues(location, allCities),
    [location, allCities]
  );
  const initialValuesKey = JSON.stringify(initialValues);

  React.useEffect(() => {
    form.setFieldsValue(initialValues);
    setErrors({});
  }, [form, initialValuesKey]);

  React.useEffect(() => {
    api.getLocationStores().then(json => {
      const stores = (json.json || []).map(store => ({
        id: store.id,
        name: store.location_name
      }));
      setLocationStores(stores);
    });
  }, []);

  const renderField = (name, render) => (
    <Form.Item name={name} noStyle>
      <FormField
        error={errors[name]}
        touched={!!errors[name]}
        onClearError={() =>
          setErrors(prevErrors => Object.assign({}, prevErrors, { [name]: undefined }))
        }
      >
        {render}
      </FormField>
    </Form.Item>
  );

  const cityChange = cityId => {
    const provinceId = form.getFieldValue('province_id');
    const citiesArray = objectToArray(allCities).filter(
      json => json.province_id == provinceId
    );
    const cities = arrayToObject(citiesArray);
    const districts = (cities && cityId && cities[cityId] && cities[cityId].districts) || [];
    if (districts.length <= 0) {
      form.setFieldsValue({ district_id: '' });
    }
  };

  const beforeUpdateLocation = formValues => {
    const model = Object.assign({}, formValues);
    if (!model.district_id) {
      delete model.district_id;
    }
    model.longitude = (model.longitude + '').trim();
    model.latitude = (model.latitude + '').trim();
    return updateLocation && updateLocation(model);
  };

  const handleFinish = () => {
    const formValues = form.getFieldsValue();
    const nextErrors = validate(formValues);
    if (Object.keys(nextErrors).some(name => !!nextErrors[name])) {
      setErrors(nextErrors);
      return;
    }

    setSubmitting(true);
    const result = beforeUpdateLocation(formValues);
    if (result && result.then) {
      return result.then(
        value => {
          setSubmitting(false);
          return value;
        },
        requestError => {
          setSubmitting(false);
          throw requestError;
        }
      );
    }
    setSubmitting(false);
    return result;
  };

  const selectDevices = (location && location.devices) || [];
  const currentLocGroups =
    (location &&
      location.location_groups &&
      location.location_groups.map(locationGroup => locationGroup.id)) ||
    [];
  const halfClass = {
    className: 'kb-form-group kb-div-c39'
  };

  return (
    <Form form={form} initialValues={initialValues} onFinish={handleFinish}>
      <KBFormError err={error} />
      <fieldset className="fieldset">
        <div className="kb-row kb-form-84">
          {renderField('name', field => (
            <KBInput
              className="kb-form-group kb-div-210"
              isRequired={true}
              title="分店名称"
              field={field}

              fistFoucs={true}
            />
          ))}
          {renderField('serial_number', field => (
            <KBInput
              className="kb-form-group kb-div-48"
              title="编号"
              field={field}

              titleClass="label-rt"
            />
          ))}
        </div>
        <div className="kb-row kb-form-84">
          {renderField('location_group_id', field => (
            <KBUserInput
              title="所属项目"
              placeholder="选择项目"
              className="kb-form-group kb-div-210"
              field={field}

              multi={false}
              users={locationGroups}
              selectedUsers={locationGroups.filter(locationGroup =>
                currentLocGroups.includes(locationGroup.id)
              )}
            />
          ))}
          {renderField('prefix', field => (
            <KBInput
              className="kb-form-group kb-div-48"
              isRequired={true}
              title="项目前缀"
              hint="用于合同和订单编号的生成"
              field={field}

              titleClass="label-rt"
            />
          ))}
        </div>
        <div className="kb-row kb-form-84">
          {renderField('location_type', field => (
            <KBSelect
              title="分店类型"
              defaultValue={'-1'}
              className="kb-form-group kb-div-210"
              field={field}

              arrayData={LOCATION_TYPES}
            />
          ))}
        </div>
        <div className="kb-row">
          {renderField('trading_area', field => (
            <KBInput
              className="kb-form-group kb-form-c18 kb-form-alone"
              field={field}

              title="所属区域"
            />
          ))}
        </div>
        <Form.Item
          noStyle
          shouldUpdate={(prev, next) =>
            prev.province_id !== next.province_id || prev.city_id !== next.city_id
          }
        >
          {({ getFieldValue }) => {
            const provinceId = getFieldValue('province_id');
            const cityId = getFieldValue('city_id');
            const citiesArray = objectToArray(allCities).filter(
              json => json.province_id == provinceId
            );
            const cities = arrayToObject(citiesArray);
            const districts =
              (cities && cityId && cities[cityId] && cities[cityId].districts) || [];

            return (
              <div className="kb-row kb-form-84">
                <div className="kb-form-66">
                  {renderField('province_id', field => (
                    <KBSelect
                      defaultValue={'-1'}
                      className="kb-form-group kb-div-48"
                      isRequired={true}
                      title="省份"
                      field={field}

                      arrayData={provinces}
                    />
                  ))}
                  {renderField('city_id', field => (
                    <KBSelect
                      defaultValue={'-1'}
                      onChange={cityChange}
                      className="kb-form-group kb-div-48"
                      isRequiredR={true}
                      title="城市"
                      titleClass="label-rt"
                      field={field}

                      arrayData={cities}
                    />
                  ))}
                </div>
                {districts.length ? (
                  renderField('district_id', field => (
                    <KBSelect
                      defaultValue={'-1'}
                      className="kb-form-group kb-div-48"
                      isRequiredR={true}
                      titleClass="label-rt"
                      title="区"
                      field={field}

                      arrayData={districts}
                    />
                  ))
                ) : (
                  <div />
                )}
              </div>
            );
          }}
        </Form.Item>
        <div className="kb-row">
          {renderField('physical_address', field => (
            <KBInput
              isRequired={true}
              className="kb-form-group kb-form-c18 kb-form-alone"
              field={field}

              title="地址"
            />
          ))}
        </div>
        <div className="kb-row kb-div-66">
          {renderField('longitude', field => (
            <KBInput {...halfClass} title="经度" field={field} />
          ))}
          {renderField('latitude', field => (
            <KBInput {...halfClass} title="纬度" field={field} titleClass="label-rt" />
          ))}
        </div>
        <div className="kb-row kb-form-84">
          <div className="kb-form-66">
            {renderField('telephone', field => (
              <KBInput
                className="kb-form-group kb-div-48"
                field={field}

                title="电话"
              />
            ))}
            {renderField('size', field => (
              <KBInput
                className="kb-form-group kb-div-48"
                inputClass="input-area"
                isRequiredR={true}
                titleClass="label-rt"
                field={field}

                title="面积"
              />
            ))}
          </div>
          {renderField('priority', field => (
            <KBInput
              className="kb-form-group kb-div-48"
              hint={'请输入数字，修改客户端的社区位置，数字越大排上面'}
              titleClass="label-rt"
              field={field}

              title="排序位"
            />
          ))}
        </div>
        <div className="kb-row">
          {renderField('price_range', field => (
            <KBInput
              title="价格范围"
              className="kb-form-group kb-form-c18 kb-form-alone"
              hint={'请输入价格范围的描述'}
              field={field}

            />
          ))}
        </div>
        <div className="kb-row">
          {renderField('location_store_id', field => (
            <KBSelect
              defaultValue=" "
              className="kb-form-group kb-div-c18 kb-form-alone"
              title="Location store"
              field={field}

              arrayData={locationStores}
            />
          ))}
        </div>
        <div className="kb-row">
          {renderField('device_ids', field => (
            <KBUserInput
              title="设备"
              selectedUsers={selectDevices}
              className="kb-form-group kb-form-c18 kb-form-alone"
              field={field}

              placeholder="选择设备"
              multi={true}
              users={devices}
            />
          ))}
        </div>
        <div className="kb-row">
          {renderField('traffic', field => (
            <KBTextarea
              hint="输入附近地铁站，主要公路等交通信息，如步行5分钟至10号线三元桥站"
              className="kb-form-group kb-form-c18 kb-form-alone"
              field={field}

              title="交通"
            />
          ))}
        </div>
        <div className="kb-row">
          {renderField('neighborhood', field => (
            <KBTextarea
              hint="输入对周边环境的表述"
              className="kb-form-group kb-form-c18 kb-form-alone"
              field={field}

              title="周边"
            />
          ))}
        </div>
        <div className="kb-row">
          {renderField('description', field => (
            <KBTextarea
              className="kb-form-group kb-form-c18 kb-form-alone"
              field={field}

              placeholder="输入简介"
              title="简介"
            />
          ))}
        </div>
      </fieldset>
      <div className="kb-row">
        <KBButton className="certain-btn" type="submit" submitting={submitting}>
          保存
        </KBButton>
      </div>
    </Form>
  );
}

const validate = values => {
  const errors = {};
  if (valid.required(values.name)) {
    errors.name = '请输入分店名称';
  }
  if (valid.required(values.prefix)) {
    errors.prefix = '请输入项目前缀';
  }
  if (values.telephone && valid.mobile(values.telephone)) {
    errors.telephone = '请输入正确的手机号码';
  }
  if (valid.required(values.size)) {
    errors.size = '请输入分店面积';
  }
  if (valid.required(values.physical_address)) {
    errors.physical_address = '请输入分店地址';
  }
  if (valid.required(values.province_id)) {
    errors.province_id = '请选择省份';
  }
  if (valid.required(values.city_id)) {
    errors.city_id = '请选择城市';
  }
  if (values.priority && valid.Int(values.priority)) {
    errors.priority = '排序只能输入数字';
  }

  return errors;
};

function mapStateToProps(state) {
  return {
    devices: selectors.getDevices(state),
    locationGroups: selectors.getLocationGroups(state)
  };
}

const getInitialValues = (location = {}, cities = {}) => {
  const cityId = location.city_id || location.city;
  return {
    name: location.name,
    location_type: location.location_type,
    serial_number: location.serial_number,
    prefix: location.prefix,
    city_id: cityId,
    traffic: location.traffic,
    neighborhood: location.neighborhood,
    longitude: location.longitude,
    latitude: location.latitude,
    district_id: location.district && location.district.id,
    province_id: cities[cityId] && cities[cityId].province_id,
    trading_area_id: location.trading_area_id,
    physical_address: location.physical_address,
    size: location.size,
    telephone: location.telephone,
    description: location.description,
    priority: location.priority,
    device_ids:
      location.devices && location.devices.length
        ? location.devices.map(device => device.id).join(',')
        : '',
    price_range: location.price_range,
    location_store_id: location.location_store_id,
    location_group_id:
      location.location_groups && location.location_groups.length
        ? location.location_groups.map(group => group.id).join(',')
        : '',
    trading_area: location.trading_area
  };
};

export default connect(mapStateToProps)(LocationBaseForm);
